import { CARGO_TYPE } from '../../cargoType';
import useAgent from '../../hooks/useAgent';
import { getTransactionsOptions } from '../hooks/useGetTransactionsOptions';

const useGetBreakbulkTransactionsOptions = () => useAgent(() => getTransactionsOptions({ cargoType: CARGO_TYPE.breakbulk }));

export default useGetBreakbulkTransactionsOptions;
